module.exports = __webpack_public_path__ + "static/media/civii.aaf8d0a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/civii.jpg
// module id = 5784
// module chunks = 0